import * as React from 'react'
import {ReactNode} from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY, CHANGE_TYPE, USER_ATTRIBUTE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    useArea: Nullable<string>
    changeType: Nullable<string>
    changeStartDate: Nullable<string>
    changeEndDate: Nullable<string>
    userFamilyName: Nullable<string>
    userFirstName: Nullable<string>
    userAttribute: Nullable<string>
    ownerFamilyName: Nullable<string>
    ownerFirstName: Nullable<string>
    carBodyShape: Nullable<string>
    carName: Nullable<string>
    carRegistrationNumber: Nullable<string>
    engineSize: Nullable<string>
    length: Nullable<string>
    height: Nullable<string>
    width: Nullable<string>
    vehicleWeight: Nullable<string>
    vehicleTotalWeight: Nullable<string>
    applyFlag?: boolean
}

const NatResidentParkingUsesChangeConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, useArea, changeType,
        changeStartDate, changeEndDate, userFamilyName, userFirstName,
        userAttribute, ownerFamilyName, ownerFirstName, carBodyShape,
        carName, carRegistrationNumber,
        engineSize, length, height, width,
        vehicleWeight, vehicleTotalWeight
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.CAR_CHANGE.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    const changeStartDateLabel = (changeStartDate) ? getFormattedDate(changeStartDate) : ''

    const changeEndDateLabel = (changeEndDate) ? getFormattedDate(changeEndDate) : ''

    const changeTypeLabel = (changeType) ? CHANGE_TYPE.codeToEnumConstants(changeType).label : ''

    const userAttributeLabel = (userAttribute) ? USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label : ''

    const userInfoLabel = userFamilyName + ' ' + userFirstName + '（' + userAttributeLabel + '）'

    const changeDateInfo = (): ReactNode => {
        const items = []
        items.push(`開始日：${changeStartDateLabel}`)
        if (changeEndDateLabel) {
            items.push(`終了日：${changeEndDateLabel}`)
        }

        return <>
            <NatResidentApplicationDetailConfirmItem
                title={'変更日'}
                items={items}
            />
        </>
    }

    const vehicleInfo = (): ReactNode => {
        const items = []
        items.push(`所有者：${ownerFamilyName} ${ownerFirstName}`)
        items.push(`形状：${carBodyShape}`)
        items.push(`車名：${carName}`)
        items.push(`自動車登録番号：${carRegistrationNumber}`)
        items.push(`排気量：${engineSize}L`)
        items.push(`外寸（長さ/高さ/幅）：${length}cm/${height}cm/${width}cm`)
        items.push(`車両重量：${vehicleWeight}kg`)
        items.push(`車両総重量：${vehicleTotalWeight}kg`)

        return <>
            <NatResidentApplicationDetailConfirmItem
                title={'変更後の車両情報'}
                items={items}
            />
            <BlockSpacer height={'5px'}/>
        </>
    }

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用区画'}
            items={[`${useArea}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'変更態様'}
            items={[`${changeTypeLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        {changeDateInfo()}
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'使用者'}
            items={[userInfoLabel]}
        />
        <BlockSpacer height={'5px'}/>
        {vehicleInfo()}
    </>)
}

NatResidentParkingUsesChangeConfirm.displayName = 'NatResidentParkingUsesChangeConfirm'
export default NatResidentParkingUsesChangeConfirm
